export default __webpack_public_path__ + "6696520f39aa3e0d5f933cd405ba434d.jpeg";